
<section class="subject-list" [style.height]="therapiesAndTrailCalculatedHeight$ | async" [ngClass]="subjectListConfig.cssClasses?.subject" *ngIf="therapiesGroups?.length > 0 && testConfiguration">
  <span class="sub-title" *ngIf="subjectListConfig.subTitle">{{subjectListConfig.subTitle}}</span>
  <header class="list-titles" [ngClass]="subjectListConfig.cssClasses?.title">
    <span *ngFor="let field of subjectListConfig.fields; trackBy: trackByIndex" [ngClass]="{'small-sizing':smallSizeTypes.includes(field.type)}">
      <ng-container *ngIf="!field.inline">
        {{field.label}}
      </ng-container>
    </span>
  </header>
  <section class="list-body" [ngClass]="subjectListConfig.cssClasses?.body"
           [ngStyle]="{maxHeight: ''}"
  >
    <gen-v-scroller
        class="full-width"
        [disabled]="testConfiguration.isPathwayTest"
        [rows]="therapiesGroups"
        [rowTemplate]="rowTemplate"
    ></gen-v-scroller>
  </section>
</section>

<ng-template let-therapiesGroup='row' #rowTemplate>
  <ispm-subject-list-row
      class="layout-row"
      [hideCheckBox]="!maxSelection || maxSelection == 1"
      [ngClass]="getRowClass(subjectId === therapiesGroup.id, subjectListConfig.cssClasses?.row, therapiesGroup.edited)"
      [value]="therapiesGroup"
      [fields]="subjectListConfig.fields"
      [formId]="formId"
      [editable]="isEditable"
      [editVisible]="editVisible"
      [selected]="subjectId === therapiesGroup.id"
      [subjectsAppearance]="subjectsAppearance"
      [subject]="subjectsAppearance.subjects[therapiesGroup.id]"
      (isTherapyChecked)="therapyCheckedEvent(therapiesGroup, $event)"
      (click)="therapyClickedEvent(therapiesGroup)"
      (editTherapyClicked)="openEditTherapy(therapiesGroup, $event)"
      (changeIncludeIn)="toggleSelection($event.includeIn, therapiesGroup?.id, $event.state)"
  ></ispm-subject-list-row>
</ng-template>
